import { Navigation2, MapPin } from "lucide-react";

/**
 * Row of quick nav buttons for a ticket:
 *   • Google Maps directions
 *   • Waze navigate
 * Falls back to a search by wilayah if no coordinates.
 */
export default function RouteButtons({ ticket, size = "sm", showLabel = true }) {
  const hasPin = typeof ticket?.lat === "number" && typeof ticket?.lng === "number";
  const wilayah = ticket?.wilayah;

  const gmapsUrl = hasPin
    ? `https://www.google.com/maps/dir/?api=1&destination=${ticket.lat},${ticket.lng}`
    : wilayah
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(wilayah)}`
    : null;

  const wazeUrl = hasPin
    ? `https://www.waze.com/ul?ll=${ticket.lat}%2C${ticket.lng}&navigate=yes`
    : wilayah
    ? `https://www.waze.com/ul?q=${encodeURIComponent(wilayah)}&navigate=yes`
    : null;

  if (!gmapsUrl && !wazeUrl) return null;

  const stop = (e) => e.stopPropagation();

  const h = size === "xs" ? "h-7 px-2 text-[10px]" : "h-8 px-3 text-xs";

  return (
    <div className="inline-flex items-center gap-1.5" data-testid="route-buttons">
      {gmapsUrl && (
        <a
          href={gmapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={stop}
          data-testid="btn-gmaps"
          className={`${h} inline-flex items-center gap-1 rounded-md bg-[#4285F4] hover:bg-[#3367D6] text-white font-semibold shadow-sm transition-colors`}
        >
          <MapPin className="h-3 w-3" />
          {showLabel && "Google Maps"}
        </a>
      )}
      {wazeUrl && (
        <a
          href={wazeUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={stop}
          data-testid="btn-waze"
          className={`${h} inline-flex items-center gap-1 rounded-md bg-[#33CCFF] hover:bg-[#1DA9E0] text-[#0A2540] font-semibold shadow-sm transition-colors`}
        >
          <Navigation2 className="h-3 w-3" />
          {showLabel && "Waze"}
        </a>
      )}
    </div>
  );
}
